import parse from "html-react-parser";
import sanitizeHtml from 'sanitize-html';

export default function parseHTML(htmlString) {
    const cleanHtml = sanitizeHtml(htmlString)
    return parse(cleanHtml)
}